(function () {
  'use strict';

  var CLASS_V1 = 'ab-free-shipping-v1';
  var CLASS_V2 = 'ab-free-shipping-v2';
  var CLASS_CURRENCY = 'ab-free-shipping-with-currency';
  var USD_V1 = 75;
  var USD_V2 = 85;
  var SKIP_TAGS = {
    SCRIPT: true,
    STYLE: true,
    NOSCRIPT: true,
    TEXTAREA: true,
    INPUT: true,
    SELECT: true,
    OPTION: true,
    CODE: true
  };
  var SYMBOLS = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    CAD: 'CA$',
    AUD: 'A$',
    NZD: 'NZ$',
    CHF: 'CHF ',
    SEK: 'SEK ',
    NOK: 'NOK ',
    DKK: 'DKK ',
    PLN: 'PLN ',
    INR: '₹',
    JPY: '¥',
    SGD: 'S$',
    HKD: 'HK$',
    MXN: 'MX$'
  };

  var originals = typeof WeakMap === 'function' ? new WeakMap() : null;
  var lastLabel = null;
  var pending = false;
  var observer = null;

  function getConfig() {
    return window.FREE_SHIPPING_THRESHOLD || {};
  }

  function getVariant() {
    var html = document.documentElement;
    if (html.classList.contains(CLASS_V2)) return 'v2';
    if (html.classList.contains(CLASS_V1)) return 'v1';
    return null;
  }

  /* Intelligems opt-in: only FX + local symbols when this class is present. */
  function shouldConvertCurrency() {
    return document.documentElement.classList.contains(CLASS_CURRENCY);
  }

  function getActiveCurrency() {
    var cfg = getConfig();
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      return String(Shopify.currency.active).toUpperCase();
    }
    return String(cfg.activeCurrency || cfg.shopCurrency || 'USD').toUpperCase();
  }

  function getCurrencyRate() {
    if (window.Shopify && Shopify.currency && Shopify.currency.rate != null) {
      var rate = parseFloat(Shopify.currency.rate);
      if (!isNaN(rate) && rate > 0) return rate;
    }
    return 1;
  }

  function stripHtml(value) {
    var container = document.createElement('div');
    container.innerHTML = value;
    return (container.textContent || '').trim();
  }

  function formatWithMoneyFormat(cents, moneyFormat) {
    var amount = (Math.max(0, cents) / 100).toFixed(2);
    var amountNoDecimals = String(Math.round(Math.max(0, cents) / 100));
    var formatted = String(moneyFormat || '${{amount}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(
        /\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
        amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      )
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);

    return stripHtml(formatted);
  }

  function formatLocalAmount(wholeAmount, currency) {
    var cfg = getConfig();
    var cents = Math.round(wholeAmount) * 100;

    if (window.Shopify && typeof Shopify.formatMoney === 'function' && cfg.moneyFormat) {
      return stripHtml(Shopify.formatMoney(cents, cfg.moneyFormat));
    }

    if (cfg.moneyFormat && currency === String(cfg.shopCurrency || 'USD').toUpperCase()) {
      return formatWithMoneyFormat(cents, cfg.moneyFormat);
    }

    var symbol = SYMBOLS[currency];
    if (symbol) {
      if (symbol.charAt(symbol.length - 1) === ' ') return symbol + wholeAmount;
      return symbol + wholeAmount;
    }

    return wholeAmount + ' ' + currency;
  }

  function formatThreshold(usdAmount) {
    if (!shouldConvertCurrency()) {
      return '$' + usdAmount;
    }

    var currency = getActiveCurrency();
    var rate = getCurrencyRate();
    var shopCurrency = String(getConfig().shopCurrency || 'USD').toUpperCase();

    /* Thresholds are USD. Convert with Shopify rate when presentment differs. */
    var wholeAmount = usdAmount;
    if (!(shopCurrency === 'USD' && currency === 'USD') && rate && Math.abs(rate - 1) >= 0.0001) {
      wholeAmount = Math.round(usdAmount * rate);
    } else if (currency !== 'USD' && shopCurrency === 'USD' && Math.abs(rate - 1) < 0.0001) {
      /* Active currency isn't USD but rate missing/1 — still format with local symbol. */
      wholeAmount = usdAmount;
    }

    if (currency === 'USD') return '$' + wholeAmount;
    return formatLocalAmount(wholeAmount, currency);
  }

  function getVariantLabel(variant) {
    if (variant === 'v1') return formatThreshold(USD_V1);
    if (variant === 'v2') return formatThreshold(USD_V2);
    return null;
  }

  function hasSourceThreshold(value) {
    /* Match $60 / $ 60 / $NBSP60 as the free-shipping threshold. */
    return /\$[\s\u00a0]?60\b/.test(value || '');
  }

  function rewriteFromSource(source, label) {
    if (!source || !label) return source;
    /* Site-wide: every $60 threshold → variant label (all theme $60s are FS copy). */
    return String(source).replace(/\$[\s\u00a0]?60\b/g, label);
  }

  function getOriginal(node) {
    if (originals && originals.has(node)) return originals.get(node);
    return node.nodeValue;
  }

  function rememberOriginal(node) {
    if (!originals || originals.has(node)) return;
    if (hasSourceThreshold(node.nodeValue)) {
      originals.set(node, node.nodeValue);
    }
  }

  var ATTR_KEYS = ['title', 'aria-label', 'alt', 'placeholder', 'data-title', 'data-content'];
  var attrOriginals = typeof WeakMap === 'function' ? new WeakMap() : null;

  function rememberAttrOriginals(el) {
    if (!attrOriginals || attrOriginals.has(el)) return;
    var saved = null;
    for (var i = 0; i < ATTR_KEYS.length; i++) {
      var key = ATTR_KEYS[i];
      if (!el.hasAttribute || !el.hasAttribute(key)) continue;
      var val = el.getAttribute(key);
      if (!hasSourceThreshold(val)) continue;
      if (!saved) saved = {};
      saved[key] = val;
    }
    if (saved) attrOriginals.set(el, saved);
  }

  function rewriteAttributes(root, label) {
    if (!root || !root.querySelectorAll) return;

    var nodes = root.querySelectorAll(
      '[title], [aria-label], [alt], [placeholder], [data-title], [data-content]',
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      rememberAttrOriginals(el);
      var saved = attrOriginals && attrOriginals.get(el);
      if (!saved) continue;

      for (var j = 0; j < ATTR_KEYS.length; j++) {
        var key = ATTR_KEYS[j];
        if (!saved[key]) continue;
        var next = label ? rewriteFromSource(saved[key], label) : saved[key];
        if (el.getAttribute(key) !== next) el.setAttribute(key, next);
      }
    }
  }

  function walk(root, label) {
    if (!root) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        if (!parent || SKIP_TAGS[parent.tagName]) return NodeFilter.FILTER_REJECT;

        if (originals && originals.has(node)) return NodeFilter.FILTER_ACCEPT;
        if (hasSourceThreshold(node.nodeValue)) return NodeFilter.FILTER_ACCEPT;
        return NodeFilter.FILTER_REJECT;
      }
    });

    var node;
    while ((node = walker.nextNode())) {
      rememberOriginal(node);
      var source = getOriginal(node);
      if (!hasSourceThreshold(source)) continue;

      var updated = label ? rewriteFromSource(source, label) : source;
      if (updated !== node.nodeValue) node.nodeValue = updated;
    }

    rewriteAttributes(root, label);
  }

  function apply() {
    pending = false;
    var variant = getVariant();
    var label = getVariantLabel(variant);

    // Control: restore originals only if we previously rewrote.
    if (!variant) {
      if (lastLabel == null) return;
      lastLabel = null;
      walk(document.body, null);
      if (document.head) walk(document.head, null);
      return;
    }

    if (label === lastLabel) {
      // Still walk so late-injected $60 copy gets converted.
    }
    lastLabel = label;

    walk(document.body, label);
    if (document.head) walk(document.head, label);

    var upcartRoot = window.upcartDocumentOrShadowRoot;
    if (upcartRoot && upcartRoot !== document && upcartRoot.body !== document.body) {
      walk(upcartRoot, label);
    }
  }

  function scheduleApply() {
    if (pending) return;
    pending = true;
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(apply);
    } else {
      setTimeout(apply, 16);
    }
  }

  function startObserver() {
    if (observer || !document.documentElement) return;

    observer = new MutationObserver(function () {
      scheduleApply();
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });

    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  function init() {
    startObserver();
    scheduleApply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
